module.exports = __webpack_public_path__ + "static/img/label-07.54f8f1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/label-07.png
// module id = A8Vd
// module chunks = 150